import React from "react";
import { motion } from "framer-motion";
import { UsersIcon } from "lucide-react";
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="w-full max-w-xl rounded-2xl border border-bad/20 bg-bad-light p-4" data-id="element-52" data-mp="2l4o1p39evveh">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-53" data-mp="2q2g3cozuyvvv">
        <span className="flex items-center gap-1.5 text-bad" data-id="element-54" data-mp="2b5ozo3j5iy0g">
          <UsersIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-55" data-mp="2g5l6sbn5b5k8" />
          Only {SPOTS_LEFT} spots left at this price
        </span>
        <span className="text-ink tabular-nums" data-id="element-56" data-mp="2273kmicw214f">{Math.round(filled)}%</span>
      </div>
      <div className="mt-2.5 h-3.5 w-full overflow-hidden rounded-full bg-white" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-57" data-mp="274dbm2fxekud">
        <motion.div className="h-full rounded-full bg-bad" initial={{
        width: "60%"
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.9,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-58" data-mp="33mv6yjuohb5q" />
      </div>
      <p className="mt-2 text-xs text-muted" data-id="element-59" data-mp="3desijrplm54z">
        When the spots run out, the price goes back to normal.
      </p>
    </div>;
}